import { render } from "./TradesTable.vue?vue&type=template&id=6edef2a0&scoped=true"
import script from "./TradesTable.vue?vue&type=script&lang=js"
export * from "./TradesTable.vue?vue&type=script&lang=js"

import "./TradesTable.vue?vue&type=style&index=0&id=6edef2a0&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edef2a0"]])

export default __exports__